import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Flame, Sparkles } from "lucide-react";
import { api } from "@/lib/api";
import { ConnectButton } from "@/components/ConnectButton";

const RANK = ["🥇", "🥈", "🥉"];

export function StreakLeaderboard() {
  const [board, setBoard] = useState([]);
  useEffect(() => {
    api.get("/checkin/leaderboard").then(({ data }) => setBoard(data.leaderboard || [])).catch(() => {});
  }, []);
  if (board.length === 0) return null;
  return (
    <div className="rud-card rounded-2xl p-4 mt-4" data-testid="streak-leaderboard">
      <div className="flex items-center gap-2 mb-3"><Flame size={16} className="text-orange-400 fill-current" /><h3 className="font-serif text-lg">Longest streaks</h3><span className="text-[11px] text-sec">— cheer each other on 🎉</span></div>
      <div className="space-y-1.5">
        {board.map((m, i) => (
          <div key={m.user_id} data-testid={`streak-row-${m.user_id}`} className="flex items-center gap-3 rounded-lg border border-rud bg-white/5 px-3 py-2">
            <span className="w-6 text-center text-sm">{RANK[i] || i + 1}</span>
            <div className="flex-1 min-w-0 flex items-center gap-1.5">
              <Link to={`/u/${m.user_id}`} className="text-sm truncate hover:text-brand transition-colors">{m.name}</Link>
              {m.kind_soul && <span data-testid={`kind-soul-${m.user_id}`} className="inline-flex items-center gap-0.5 text-[10px] text-brand bg-brand/15 rounded-full px-1.5 py-0.5"><Sparkles size={10} /> Kind Soul</span>}
            </div>
            <span className="text-xs text-orange-400 flex items-center gap-1 shrink-0"><Flame size={12} className="fill-current" /> {m.streak}d</span>
            <ConnectButton userId={m.user_id} size="xs" />
          </div>
        ))}
      </div>
    </div>
  );
}

export default StreakLeaderboard;
